import React from 'react';
export function PainPoints() {
  const points = ['Te sentís "pesada" sin saber por qué, como si cargás una mochila que nunca elegiste.', 'Repetís los mismos patrones en el amor, el dinero o la salud que vivieron tu madre y tu abuela.', 'Tenés dolores o bloqueos en tu zona pélvica, vientre o pecho que la medicina convencional no termina de resolver.', 'Cada vez que hablás con tu mamá, quedás agotada, culpable o enojada… y no sabés cómo salir de ese loop.', 'Sentís que tus abuelas, tu madre o las mujeres de tu familia "marcaron" tu forma de vivir el amor, el dinero y el cuerpo.', 'Empezaste mil procesos de sanación pero sentís que algo más profundo todavía no se movió.'];
  return <section className="py-8 px-4 bg-soft-rose" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-97">
          Esta página es para vos si…
        </h2>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-soft" data-id="element-98">
          <ul className="space-y-4" data-id="element-99">
            {points.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-100">
                <span className="text-xl flex-shrink-0 mt-1" data-id="element-101">😔</span>
                <p className="text-base text-warm-brown-dark leading-relaxed" data-id="element-102">
                  {point}
                </p>
              </li>)}
          </ul>

          <div className="mt-8 pt-6 border-t border-soft-rose-dark text-center" data-id="element-103">
            <h3 className="text-lg md:text-xl font-semibold text-deep-rose" data-id="element-104">
              Si dijiste "sí" a alguna de estas frases… lo que vas a descubrir
              hoy puede cambiar no solo tu vida, sino la de las generaciones que
              vienen.
            </h3>
          </div>
        </div>
      </div>
    </section>;
}